
import { gql } from 'graphql-request';
import API from 'services/api';

const deleteUser = async (id: number): Promise<boolean> => {
    return await API.graphql(gql`
        mutation {
            deleteUser(
                id: ${id}
            )
        }
    `);
};

export default deleteUser;
